// extracted by mini-css-extract-plugin
export default {"markdown-editor":"Markdown_markdown-editor__VuRO0","clickable-box":"Markdown_clickable-box__NxWIS","pencil-icon":"Markdown_pencil-icon__6iQ7o"};